<mat-form-field class="no-truncate" [class]="config?.alignment ?? GridCellContentAlignment.Left">
  <mat-select
    [panelClass]="colorOptions?.allowColorPicker ? 'selectPanelWithColors' : ''"
    [(ngModel)]="context.data[context.column.columnDef]"
    [disabled]="!context.cell.allowEditing"
    (selectionChange)="context.cell.actions.onEdited()"
  >
    <mat-option data-testId="search-option">
      <ngx-mat-select-search
        #matSelectSearch
        [formControl]="filterControl"
        [placeholderLabel]="config?.searchPlaceholderLabel ?? 'Search'"
        [noEntriesFoundLabel]="config?.searchNoEntriesFoundLabel ?? 'No search results'"
      >
        <mat-icon color="primary" svgIcon="close" ngxMatSelectSearchClear></mat-icon>
      </ngx-mat-select-search>
    </mat-option>

    <div [class]="colorOptions?.allowColorPicker ? 'optionsWrapper' : ''">
      <mat-option
        [attr.data-testId]="config?.noneOptionName ?? 'None'"
        *ngIf="config?.includeNoneOption"
        [value]="null"
      >
        {{config?.noneOptionName ?? 'None' }}
      </mat-option>
      <mat-option
        [attr.data-testId]="option.name"
        *ngFor="let option of filteredOptions$ | async; trackBy: trackByFunction"
        [value]="option.id"
      >
        {{option.name}}
      </mat-option>
    </div>

    <footer *ngIf="colorOptions?.allowColorPicker" class="d-flex justify-content-center border-top">
      <app-color-picker
        [options]="colorOptions"
        [context]="context"
        [isEditMode]="select?.focused"
        (colorSelected)="select.close()"
      ></app-color-picker>
    </footer>
  </mat-select>
</mat-form-field>
